export const TOKENS_COLOR_DEFAULT = {
    light: {
        background: {
            'category-live': '#FF383C',
            brand: {
                primary: '#18191B',
                secondary: '{background.neutral.secondary}',
                tertiary: '{background.neutral.primary}',
            },
            'neutral-inverse': {
                primary: '#18191B',
                secondary: '#464749',
                tertiary: '#65676B',
            },
            neutral: {
                primary: '#FFFFFF',
                secondary: '#F3F3F3',
                tertiary: '#E8E8E8',
                disabled: '#F3F3F3',
            },
            semantic: {
                success: {
                    subtle: '#ECFFF8',
                    bold: '#19B27A',
                },
                warning: {
                    subtle: '#FFEEE7',
                    bold: '#FF5C16',
                },
                error: {
                    subtle: '#FFEAE9',
                    bold: '#FF3326',
                },
                info: {
                    subtle: '#E5EFFF',
                    bold: '#0064FF',
                },
                pending: {
                    subtle: '#FFFBE5',
                    bold: '#FFD700',
                },
            },
            pager: {
                active: '#18191B',
                inactive: '#E8E8E8',
            },
            static: {
                white: '#FFFFFF',
                black: '#000000',
                kakao: '#FEE500',
                naver: '#03C75A',
            },
            component: {
                card: '{background.neutral.primary}',
                skeleton: '{background.neutral.tertiary}',
                'skeleton-indicator': '#D1D1D1',
                memo: '#EEE5B0',
                broadcast: '#F2F2F2',
                'image-placeholder': '{background.neutral.secondary}',
                'home-screen': '#F2F2F2',
                'rank-profile-1': '#80FF75',
                'rank-profile-2': '#FFD600',
                'rank-profile-3': '#3CC4FF',
            },
        },
        text: {
            neutral: {
                primary: '#18191B',
                secondary: '#65676B',
                tertiary: '#7B7D80',
                disabled: '#A3A3A4',
            },
            'neutral-inverse': {
                primary: '#F3F3F3',
                secondary: '#E8E8E8',
                tertiary: '#D1D1D1',
            },
            brand: {
                primary: '#FFFFFF',
                inverse: '{text.neutral.primary}',
            },
            semantic: {
                success: {
                    primary: '#19B27A',
                    inverse: '#ECFFF8',
                },
                warning: {
                    primary: '#FF5C16',
                    inverse: '#FFEEE7',
                },
                error: {
                    primary: '#FF3326',
                    inverse: '#FFEAE9',
                },
                info: {
                    primary: '#0064FF',
                    inverse: '#E5EFFF',
                },
                pending: {
                    primary: '#AD9200',
                    inverse: '#FFFFFF',
                },
            },
            component: {
                'card-caption': '{text.neutral.tertiary}',
                badge: '{text.neutral.tertiary}',
                'category-label': '{text.neutral.tertiary}',
                'empty-state': '{text.neutral.secondary}',
                footer: '{text.neutral.tertiary}',
                'footer-link': '{text.semantic.warning.primary}',
                'message-own': '{text.neutral-inverse.primary}',
                'message-deleted': '{text.neutral.tertiary}',
                'empty-title': '{text.neutral.primary}',
                'winner-name': '#FFD700',
                'giveaway-winner': '#00FFBB',
                'avatar-initial': '#000000',
                'shipping-fee': '#000000',
                'card-caption-secondary': '{text.neutral.tertiary}',
                'home-title': '#000000',
                'home-empty-message': '#000000',
            },
            static: {
                white: '#FFFFFF',
                black: '#18191B',
            },
        },
        border: {
            neutral: {
                primary: '#E8E8E8',
                secondary: '#A3A3A4',
            },
            'neutral-inverse': {
                primary: '#65676B',
                secondary: '#7B7D80',
            },
            brand: {
                primary: '{border.neutral.secondary}',
                inverse: '#F3F3F3',
            },
            semantic: {
                success: {
                    primary: '#19B27A',
                    inverse: '#ECFFF8',
                },
                warning: {
                    primary: '#FF5C16',
                    inverse: '#FFD1BE',
                },
                error: {
                    primary: '#DD2114',
                    inverse: '#FFBDB8',
                },
                info: {
                    primary: '#2E80FF',
                    inverse: '#B7D3FF',
                },
                pending: {
                    primary: '#FFD700',
                    inverse: '#FFF4B7',
                },
            },
            static: {
                white: '#FFFFFF',
                black: '#18191B',
            },
            component: {
                'social-button': '{border.static.black}',
                badge: '{border.neutral.primary}',
                'category-selected': '#000000',
            },
        },
        icon: {
            'brand-primary': '{icon.neutral-primary}',
            'brand-inverse': '#FFFFFF',
            'neutral-primary': '#18191B',
            'neutral-secondary': '#65676B',
            'neutral-tertiary': '#7B7D80',
            'neutral-disabled': '#A3A3A4',
            'neutral-inverse-primary': '#F3F3F3',
            'neutral-inverse-secondary': '#E8E8E8',
            'neutral-inverse-tertiary': '#D1D1D1',
            'semantic-success': '#19B27A',
            'semantic-warning': '#FF5C16',
            'semantic-error': '#FF3326',
            'semantic-info': '#0064FF',
            'semantic-pending': '#D6B500',
            'tab-active': '{icon.neutral-primary}',
            'tab-inactive': '#8B8C8D',
            'static-white': '#FFFFFF',
            'static-black': '#18191B',
            'component-add': '{icon.neutral-primary}',
            'component-shipping-fee': '#000000',
        },
    },
    dark: {
        background: {
            'category-live': '#FF383C',
            brand: {
                primary: '#FFFFFF',
                secondary: '{background.neutral.secondary}',
                tertiary: '{background.neutral.primary}',
            },
            'neutral-inverse': {
                primary: '#18191B',
                secondary: '#464749',
                tertiary: '#65676B',
            },
            neutral: {
                primary: '#1F2023',
                secondary: '#323337',
                tertiary: '#414246',
                disabled: '#323337',
            },
            semantic: {
                success: {
                    subtle: '#1E3A33',
                    bold: '#19B27A',
                },
                warning: {
                    subtle: '#472B1F',
                    bold: '#FF5C16',
                },
                error: {
                    subtle: '#472324',
                    bold: '#FF3326',
                },
                info: {
                    subtle: '#192C4B',
                    bold: '#0064FF',
                },
                pending: {
                    subtle: '#47411D',
                    bold: '#FFD700',
                },
            },
            pager: {
                active: '#6B6D73',
                inactive: '#FFFFFF',
            },
            static: {
                white: '#FFFFFF',
                black: '#000000',
                kakao: '#FEE500',
                naver: '#03C75A',
            },
            component: {
                card: '{background.neutral.secondary}',
                skeleton: '{background.neutral.secondary}',
                'skeleton-indicator': '{background.neutral.tertiary}',
                memo: '#EEE5B0',
                broadcast: '#F2F2F2',
                'image-placeholder': '#F3F3F3',
                'home-screen': '{background.neutral.primary}',
                'rank-profile-1': '#80FF75',
                'rank-profile-2': '#FFD600',
                'rank-profile-3': '#3CC4FF',
            },
        },
        text: {
            neutral: {
                primary: '#FFFFFF',
                secondary: '#C8C9D2',
                tertiary: '#ADAFBA',
                disabled: '#7A7B80',
            },
            'neutral-inverse': {
                primary: '#F3F3F3',
                secondary: '#E8E8E8',
                tertiary: '#D1D1D1',
            },
            brand: {
                primary: '#18191B',
                inverse: '{text.neutral.primary}',
            },
            semantic: {
                success: {
                    primary: '#19B27A',
                    inverse: '#ECFFF8',
                },
                warning: {
                    primary: '#FF5C16',
                    inverse: '#FFEEE7',
                },
                error: {
                    primary: '#FF3326',
                    inverse: '#FFEAE9',
                },
                info: {
                    primary: '#4D94FF',
                    inverse: '#E5EFFF',
                },
                pending: {
                    primary: '#FFD700',
                    inverse: '#FFFFFF',
                },
            },
            component: {
                'card-caption': '#9DA0A4',
                badge: '#A5A7AB',
                'category-label': '{text.neutral.secondary}',
                'empty-state': '{text.neutral.tertiary}',
                footer: '{text.neutral.disabled}',
                'footer-link': '{text.neutral.disabled}',
                'message-own': '{text.brand.primary}',
                'message-deleted': '#65676B',
                'empty-title': '{text.neutral.tertiary}',
                'winner-name': '#FFD700',
                'giveaway-winner': '#00FFBB',
                'avatar-initial': '#000000',
                'shipping-fee': '#000000',
                'card-caption-secondary': '#7B7D80',
                'home-title': '{text.neutral.primary}',
                'home-empty-message': '{text.neutral.tertiary}',
            },
            static: {
                white: '#FFFFFF',
                black: '#18191B',
            },
        },
        border: {
            neutral: {
                primary: '#414246',
                secondary: '#5C5D5F',
            },
            'neutral-inverse': {
                primary: '#65676B',
                secondary: '#7B7D80',
            },
            brand: {
                primary: '{border.neutral.secondary}',
                inverse: '#323337',
            },
            semantic: {
                success: {
                    primary: '#19B27A',
                    inverse: '#1F5A49',
                },
                warning: {
                    primary: '#FF5C16',
                    inverse: '#7A3A1C',
                },
                error: {
                    primary: '#FF3326',
                    inverse: '#7A2B27',
                },
                info: {
                    primary: '#2E80FF',
                    inverse: '#1F4580',
                },
                pending: {
                    primary: '#FFD700',
                    inverse: '#7A6A14',
                },
            },
            static: {
                white: '#FFFFFF',
                black: '#18191B',
            },
            component: {
                'social-button': '{border.neutral.primary}',
                badge: '{border.neutral.secondary}',
                'category-selected': '{border.static.white}',
            },
        },
        icon: {
            'brand-primary': '{icon.neutral-primary}',
            'brand-inverse': '#18191B',
            'neutral-primary': '#FFFFFF',
            'neutral-secondary': '#C8C9D2',
            'neutral-tertiary': '#ADAFBA',
            'neutral-disabled': '#7A7B80',
            'neutral-inverse-primary': '#F3F3F3',
            'neutral-inverse-secondary': '#E8E8E8',
            'neutral-inverse-tertiary': '#D1D1D1',
            'semantic-success': '#19B27A',
            'semantic-warning': '#FF5C16',
            'semantic-error': '#FF3326',
            'semantic-info': '#4D94FF',
            'semantic-pending': '#FFD700',
            'tab-active': '{icon.neutral-primary}',
            'tab-inactive': '#7A7B80',
            'static-white': '#FFFFFF',
            'static-black': '#18191B',
            'component-add': '{background.neutral.tertiary}',
            'component-shipping-fee': '#000000',
        },
    },
};
export const TOKENS_SIZE_DEFAULT = {
    fontSize: {
        '4xs': 8,
        '4xs-plus': 9,
        '3xs': 10,
        '2xs': 11,
        xs: 12,
        'xs-plus': 13,
        sm: 14,
        'sm-plus': 15,
        base: 16,
        'base-plus': 18,
        lg: 19,
        'lg-plus': 20,
        xl: 23,
        '2xl': 24,
        '3xl': 32,
        '4xl': 40,
    },
    radius: {
        xxs: 2,
        xs: 4,
        'xs-plus': 6,
        s: 8,
        's-plus': 10,
        m: 12,
        'category-icon': 12.75,
        'm-plus': 16,
        l: 20,
        xl: 32,
        full: 9999,
    },
    spacing: {
        xxxs: 1,
        xxs: 2,
        xs: 4,
        'xs-mid': 5,
        'xs-plus': 6,
        s: 8,
        's-plus': 10,
        m: 12,
        'm-plus': 16,
        l: 20,
        'l-mid': 22,
        'l-plus': 24,
        xl: 32,
        '4xl': 80,
    },
    dimension: {
        '3xs': 12,
        '2xs': 16,
        xs: 20,
        s: 24,
        's-plus': 28,
        m: 32,
        'm-plus': 36,
        l: 40,
        'l-plus': 44,
        xl: 48,
        'xl-plus': 52,
        '2xl': 56,
        '2xl-plus': 60,
        '3xl': 64,
        '3xl-plus': 70,
        '4xl': 80,
        '5xl': 96,
    },
};
//# sourceMappingURL=tokens-default.generated.js.map